import React, {useState} from "react";
import styled from "styled-components";

const FoldableOption = ({isOpen, children, title}) => {
    const [open, setOpen] = useState(isOpen)
    const toggle = () => {
        setOpen(prev => !prev)
    }
    return (
        <ModalOption isOpen={open}>
            <div onClick={toggle} className="header">
                <div className="title">{title}</div>
                <i className="fas fa-chevron-down"></i>
            </div>
            <div className="inner">
                {children}
            </div>
        </ModalOption>
    )
}


const ModalOption = styled.div`
  display: flex;
  flex-direction: column;
  transition: 1000ms;
  margin-bottom: 15px;

  .header {
    display: flex;
    justify-content: space-between;
    height: 40px;
    border-radius: 10px;
    cursor: pointer;
    background: #E8E8E8;
    padding-left: 25px;
    padding-right: 25px;
    align-items: center;
    margin-bottom: 15px;

    .title {
      font-size: 16px;
      font-weight: 700;
    }

    .fas {
      transition: 400ms;
      transform: rotate(${(p) => (p.isOpen ? '180deg' : '0')});

    }
  }

  .inner {
    transition: 400ms;
    display: flex;
    flex-direction: column;
    height: max-content;
    max-height: ${(p) => (p.isOpen ? '600px' : '0')};
    overflow: auto;
    padding-left: 20px;
    padding-right: 20px;
    font-weight: normal;

  }

`
export default FoldableOption